module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Regular.3f63bdd.woff2";